/*

{
    id: 1, title: '信用目录公示', image: require('@/static/images/index/1.png'), link: '/publicity/honestMenu'
},

*/
export const TOP = [{
    // id: 2, title: '企业经营异常名录查询', image: require('@/static/images/index/2.png'), link: '/server/abnormal_find'
    id: 2, title: '企业经营异常名录查询', image: require('@/static/images/index/2.png'),link: 'https://www.gsxt.gov.cn/index.html', // 修改为外部系统地址
}, {
    id: 3, title: '统一社会信用代码查询', image: require('@/static/images/index/3.png'), link: '/server/social_find'
}, {
    id: 4, title: '行政许可/行政处罚查询', image: require('@/static/images/index/4.png'), link: '/server/administrat_find'
}, {
    id: 5, title: '红名单查询', image: require('@/static/images/index/5.png'), link: '/publicity/honour'
}, {
    id: 6, title: '黑名单查询', image: require('@/static/images/index/6.png'), link: '/publicity/break'
}, {
    id: 7, title: '失信被执行人', image: require('@/static/images/index/7.png'), link: '/server/break'
}, {
    id: 8, title: '信用评价', image: require('@/static/images/server/13.png'), link: "/supervision",
}]


export const BOTTOM = [{
    id: 1, title: '异议申诉', image: require('@/static/images/index/8.png'), link: '/server/representation'
}, {
    id: 2, title: '诚信宣传', image: require('@/static/images/index/9.png'), link: '/common/typical'
}, {
    id: 3, title: '联合奖惩', image: require('@/static/images/index/10.png'), link: '/common/rewardsPunishments'
}, {
    id: 4, title: '信用承诺', image: require('@/static/images/index/11.png'), link: '/promise'
}]


export const LINKLIST = [
    {
        title: '信用中国',
        link: 'https://www.creditchina.gov.cn/',
        image: require('@/static/images/link-zg.jpg'),
    },
    {
        title: '山东省人民政府',
        link: 'http://www.shandong.gov.cn/',
        image: require('@/static/images/link-sd.jpg'),
    },
    {
        title: '肥城',
        link: 'https://www.gsxt.gov.cn/',
        image: require('@/static/images/gjqyxyxxgs.png'),
    },
    {
        title: '中国执行信息公开网',
        link: 'http://zxgk.court.gov.cn/',
        image: require('@/static/images/link-xy.png'),
    },
]

// 不要改变顺序，切记
export const NAVLIST = [
    {
        id: 0,
        title: '首页',
        link: '/',
        href: '/'
    },
    {
        id: 1,
        title: '信用动态',
        link: '/common/dynamics',
        href: '/common/dynamics/国内动态',
        image: require('@/static/images/dynamics/7.png'),
    },
    {
        id: 2,
        title: '信用服务',
        href: '/server/main',
        link: '/server/main',
        image: require('@/static/images/dynamics/9.png'),
    },
    {
        id: 3,
        title: '信用公示',
        href: '/publicity/main',
        link: '/publicity/main',
        image: require('@/static/images/dynamics/8.png'),
    },
    {
        id: 4,
        title: '政策法规',
        href: '/common/policy',
        link: '/common/policy',
        image: require('@/static/images/dynamics/5.png'),
    },
    {
        id: 5,
        title: '风险提示',
        href: '/common/risks',
        link: '/common/risks',
    },
    {
        id: 6,
        title: '诚信宣传',
        href: '/common/typical',
        link: '/common/typical',
        image: require('@/static/images/dynamics/4.png'),
    },
    {
        id: 7,
        title: '联合奖惩',
        href: '/common/rewardsPunishments',
        link: '/common/rewardsPunishments',
        image: require('@/static/images/dynamics/6.png'),
    },
    {
        id: 8,
        title: '信用研究',
        href: '/common/research',
        link: '/common/research',
    },
    {
        id: 9,
        title: '专项治理',
        href: '/common/special',
        link: '/common/special',
        image: require('@/static/images/dynamics/3.png'),
    },
    {
        id: 10,
        title: '行业信用',
        href: '/common/industries',
        link: '/common/industries',
        image: require('@/static/images/dynamics/2.png'),
    },
    {
        id: 11,
        title: '信用承诺',
        href: '/promise',
        link: '/promise',
    },
]

export const TOPLIST = [
    {
        id: 1,
        title: '信用信息',
        placeholder: '请输入法人名称',
    },
    {
        id: 2,
        title: '统一社会信用代码',
        placeholder: '请输入法人名称或统一社会信用代码',
    },
    {
        id: 3,
        title: '文章',
        placeholder: '请输入文章标题或内容',
    },
]
